module.exports = __webpack_public_path__ + "static/media/edna41.c99dd7b9.png";